import React from "react";
import { cn } from "../../../helpers/classNames.helper";
import { markLinksFromString } from "../../../helpers/markLinksFromString.helper";
import S from "./Text.module.scss";

interface TextWithChildren {
    html?: never;
    children: React.ReactNode;
}

interface TextWithString {
    html: string;
    children?: never;
}

interface BaseProps {
    bold?: boolean;
    dimmed?: boolean;
    noPadding?: boolean;
    smallText?: boolean;
    largeText?: boolean;
    alignCenter?: boolean;
    className?: string;
}

export type HMF_TextProps = BaseProps & (TextWithChildren | TextWithString);

export const HMF_Text = (props: HMF_TextProps) => {
    const combinedClassNames = cn(
        S.wrapper,
        props.className,
        props.alignCenter && S.alignCenter,
        props.bold && S.bold,
        props.dimmed && S.dimmed,
        props.noPadding || S.paddingBottom,
        props.smallText && S.smallText,
        props.largeText && S.largeText
    );

    return props.html ? (
        <div
            className={combinedClassNames}
            dangerouslySetInnerHTML={{
                __html: markLinksFromString(props.html),
            }}
        />
    ) : (
        <div className={combinedClassNames}>{props.children}</div>
    );
};
